import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import GetAppIcon from "@material-ui/icons/GetApp";
import React from "react";
import { useNotify, useTranslate } from "react-admin";

import { downloadFileWithNotification } from "utils/download";

export const DownloadAllControl = ({ recordId, disabled, documentsCount }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const [loading, setLoading] = React.useState(false);

	const isDownloadAllDisabled = disabled || loading || documentsCount === 0;

	const handleDownloadAll = React.useCallback(async () => {
		setLoading(true);
		try {
			await downloadFileWithNotification(
				`/files/orders/${recordId}/documents`,
				null,
				(error) => notify(error?.message || String(error), { type: "error" })
			);
		} finally {
			setLoading(false);
		}
	}, [recordId, notify]);

	return (
		<Button
			variant="text"
			color="primary"
			disabled={isDownloadAllDisabled}
			startIcon={loading ? <CircularProgress size={16} thickness={5} /> : <GetAppIcon />}
			onClick={handleDownloadAll}
		>
			{translate("osfc.fields.document.download_all")}
		</Button>
	);
};
